import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBox from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlank from "@material-ui/icons/CheckBoxOutlineBlank";
import Api from "../../services/Api";
import { showNotification as showNotificationAction, refreshView as refreshViewAction, translate } from "react-admin";

class ActiveButton extends Component {
  handleClick = (event) => {
    const { record, showNotification, refreshView } = this.props;
    const updatedRecord = { ...record, active: event.target.checked };

    Api.putCampaign(record.originId, updatedRecord).then((response) => {
      showNotification("resources.campaigns.updated", "info", { messageArgs: { title: record.title } });
      refreshView();
    });

  };

  render() {
    const { record } = this.props;
    return (<FormControlLabel
      control={
        <Checkbox
          checked={record.active}
          icon={<CheckBoxOutlineBlank/>}
          checkedIcon={<CheckBox/>}
          value={`${record.active}`}
          onChange={this.handleClick}
        />
      }
    />);
  }
}

ActiveButton.propTypes = {
  record: PropTypes.object,
  showNotification: PropTypes.func,
  FavouriteButton: PropTypes.func,
  translate: PropTypes.func
};

export default connect(null, {
  showNotification: showNotificationAction,
  refreshView: refreshViewAction
})(translate(ActiveButton));
